import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { showError, showWarning } from '@/utils/toast';

// Shared error handling for the network-fetching hooks: a deleted network
// (tRPC "Network not found") warns and redirects home, anything else surfaces
// a generic load-failure toast.
export const useNetworkLoadErrorEffect = error => {
  const $ = _c(4);
  const router = useRouter();
  let t0;
  let t1;
  if ($[0] !== error || $[1] !== router) {
    t0 = () => {
      if (error) {
        if (error.message === "Network not found") {
          showWarning("Network has been deleted.", {
            description: "Redirecting to home page..."
          });
          router.push("/");
        } else {
          showError("Failed to load network.", {
            description: "Check your internet connection and try again."
          });
        }
      }
    };
    t1 = [error, router];
    $[0] = error;
    $[1] = router;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
};